import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clasificacion'
})
export class ClasificacionPipe implements PipeTransform {

  transform(clasificacion: string): string {
    switch(clasificacion) {
        case 'rojo': return '🔴 ';
        case 'morado': return '🟣 ';
        case 'azul': return '🔵 ';
        case 'narenja': return '🟠 ';
        case 'verde': return '🟢 ';
        case 'gris': return '⚪ ';
        default: return '';
    }
  }

}